import React, { useState } from 'react';
import { useLabels } from 'wsm-common-data';
import { useSelector } from 'react-redux';
import AllHighlightedFeaturesLink from './AllHighlightedFeaturesLink';
import HighlightedFeaturesModal from './HighlightedFeaturesModal';

const AllHighlightedFeatures = () => {
	const [isOpenModal, setOpenModal] = useState(false);
	const features = useSelector((state) => state.features);
	const labels = useLabels();

	const toggleOpenModal = () => {
		setOpenModal((previous) => !previous);
	};

	const modalTitle = labels.get('HIGHLIGHTED_FEATURES');
	const displayText = labels
		.get('VIEW_ALL_X_HIGHLIGHTS')
		.replace('{count}', features.length);

	return (
		<>
			<AllHighlightedFeaturesLink
				onClick={toggleOpenModal}
				displayText={displayText}
			/>
			{isOpenModal && (
				<HighlightedFeaturesModal
					features={features}
					title={modalTitle}
					onClose={toggleOpenModal}
					isOpen={isOpenModal}
				/>
			)}
		</>
	);
};

export default AllHighlightedFeatures;
